"use client";

import { c as _c } from "react/compiler-runtime";
import { startTransition, useMemo, useState } from "react";
import { ButtonRadialFill } from "@/components/button-radial-fill";
import { CaseCard } from "@/layouts/webparts/cases/case-card";
import { getProjectTypeTag, projectMatchesType } from "@/lib/project-types";
import type { HomeProject } from "@/lib/projects";
import { useCasesGalleryAnimation } from "./use-cases-gallery-animation";
type CasesGalleryProps = {
  projects: HomeProject[];
};
const ALL_FILTER = "Todos";
const FILTERS = [ALL_FILTER, "Sistemas", "Aplicativos", "Sites"] as const;

/** Total histórico de entregas — não é o número de cases publicados na galeria. */
const DELIVERED_PROJECTS = 350;
function matchesFilter(project: HomeProject, filter: string) {
  if (filter === ALL_FILTER) {
    return true;
  }
  return projectMatchesType(project, filter);
}
export function CasesGallery(t0) {
  const $ = _c(29);
  const {
    projects
  } = t0;
  const [activeFilter, setActiveFilter] = useState(ALL_FILTER);
  let t1;
  if ($[0] !== activeFilter || $[1] !== projects) {
    let t2;
    if ($[3] !== activeFilter) {
      t2 = project => matchesFilter(project, activeFilter);
      $[3] = activeFilter;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = projects.filter(t2);
    $[0] = activeFilter;
    $[1] = projects;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const filteredProjects = t1;
  const visibleProjects = filteredProjects;
  let t2;
  if ($[5] !== visibleProjects) {
    t2 = visibleProjects.map(_temp).join("|");
    $[5] = visibleProjects;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const animationKey = t2;
  const {
    gridRef
  } = useCasesGalleryAnimation(animationKey);
  let t3;
  if ($[7] !== activeFilter) {
    t3 = FILTERS.map(filter => <ButtonRadialFill className={["border-r border-gray-300 max-md:min-w-50 px-5 xl:px-10 py-5 first:border-x max-sm:border-x", activeFilter === filter ? "bg-primary-300 text-white" : "text-gray-500 hover:text-white"].join(" ")} classNameFill="bg-primary-300" key={filter} onClick={() => {
      startTransition(() => {
        setActiveFilter(filter);
      });
    }}>{filter}</ButtonRadialFill>);
    $[7] = activeFilter;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <div className="flex items-center justify-center">{t3}</div>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="text-white max-lg:py-5 hidden md:block">+ de {DELIVERED_PROJECTS} projetos realizados</div>;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4) {
    t6 = <div className="container md:border-x md:border-gray-300 relative hidden md:block"><div className="flex items-center justify-between md:px-6 lg:px-18 3xl:px-24!">{t4}{t5}</div></div>;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== activeFilter) {
    t7 = FILTERS.map(filter_0 => <ButtonRadialFill className={["border-r border-gray-300 max-md:min-w-50 px-5 xl:px-10 py-4 first:border-x max-sm:border-x", activeFilter === filter_0 ? "bg-primary-300 text-white" : "text-gray-500 hover:text-white"].join(" ")} classNameFill="bg-primary-300" key={filter_0} onClick={() => {
      startTransition(() => {
        setActiveFilter(filter_0);
      });
    }}>{filter_0}</ButtonRadialFill>);
    $[14] = activeFilter;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <div className="block md:hidden overflow-x-auto! overflow-visible"><div className="flex items-center justify-between"><div className="flex items-center justify-center">{t7}</div></div></div>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t6 || $[19] !== t8) {
    t9 = <div className="md:container-padding md:sticky top-17 z-40 bg-gray-1000 border-y border-gray-300">{t6}{t8}</div>;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="text-white max-lg:py-5 block md:hidden mt-4 px-6">+ de {DELIVERED_PROJECTS} projetos realizados</div>;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== filteredProjects.length || $[23] !== gridRef || $[24] !== visibleProjects) {
    t11 = <div className="md:container-padding"><div className="container md:border-x md:border-gray-300">{t10}{filteredProjects.length > 0 ? <><div ref={gridRef} className="relative grid gap-x-10 gap-y-16 px-6 lg:px-18 3xl:px-24! pb-16 pt-6 md:pt-18 md:grid-cols-2 md:gap-y-24 xl:grid-cols-3 max-md:items-center"><span className="hidden md:inline-flex -top-1.75 -left-1.75 absolute h-3 w-3 border border-gray-300 bg-gray-1000 z-40" /><span className="hidden md:inline-flex -top-1.75 -right-1.75 absolute h-3 w-3 border border-gray-300 bg-gray-1000 z-40" />{visibleProjects.map(_temp2)}</div></> : <div className="px-6 py-16 text-center text-gray-400">Nenhum case encontrado para esse filtro.</div>}</div></div>;
    $[22] = filteredProjects.length;
    $[23] = gridRef;
    $[24] = visibleProjects;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t9) {
    t12 = <section className="cases-gallery-section relative">{t9}{t11}</section>;
    $[26] = t11;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}
function _temp2(project_1) {
  return <div className="mx-auto w-full max-w-95" key={project_1.slug}><CaseCard project={project_1} tag={getProjectTypeTag(project_1)} /></div>;
}
function _temp(project_0) {
  return project_0.slug;
}